<template>
  <div class="lang-select">
    <div class="view-lang" @click="clickLangListToggle">
      <img
        class="icon"
        src="~/assets/pages/common/IconLanguage.svg"
        :alt="$t('util.lang_select')"
      />
      <div class="text">{{ $t('select_language') }}</div>
    </div>
    <div ref="langSelectList" v-if="isShowLangSelectList" class="lang-select-list">
      <div
        v-for="l in locales"
        class="lang"
        :key="l.code"
        @click="clickSelectLang(l.code)"
      >
        <div class="text">
          {{ l.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { locales, setLocale } = useI18n()

// 言語
const langSelectList = ref(null)
const isShowLangSelectList = ref<boolean>(false)

// 言語セレクタの表示切替
const clickLangListToggle = () => {
  isShowLangSelectList.value = !isShowLangSelectList.value
}

const clickSelectLang = async (locale: 'ja' | 'en') => {
  await setLocale(locale)
  isShowLangSelectList.value = false
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

/* 言語セレクタ */
.lang-select {
  position: relative;
  width: 56px;
  height: 56px;
  user-select: none;
  cursor: pointer;
  text-align: center;
  mix-blend-mode: difference;

  /* テキスト */
  .text {
    color: v.$text-lang-select-color;
    font-size: 1rem;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    letter-spacing: 0;
    line-height: 1rem;
    mix-blend-mode: difference;
  }

  /* 表示中の言語 */
  .view-lang {
    align-items: center;
    background: v.$bg-lang-select-color;
    border-bottom: 1px solid rgba(255, 255 ,255, 0.2);
    display: flex;
    row-gap: 4px;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    text-align: center;
    transition: all 0.3s;

    /* アイコン */
    .icon {
      display: block;
      width: 16px;
      height: 16px;
      mix-blend-mode: difference;
    }
  }

  /* 言語選択部 */
  .lang-select-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    mix-blend-mode: difference;

    /* 各言語部 */
    .lang {
      padding: 10px;
      background: v.$bg-lang-select-color;
      border-bottom: 1px solid rgba(255, 255 ,255, 0.2);
      mix-blend-mode: difference;

      .text {
        position: relative;
        line-height: 16px;
        mix-blend-mode: difference;

        /* 点の表示 */
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          border-style: solid;
          border-width: 3px 0 3px 3px;
          border-color: transparent currentColor;
          mix-blend-mode: difference;
        }
      }
    }
  }
}
</style>
